var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000003815521786890174580000004430240468328647042_);fill:none;stroke:#000000;stroke-width:47;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000151528832686453339230000012247487864567976605_);fill:none;stroke:#000000;stroke-width:47;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000150815608062833152320000001670272837935777719_);fill:none;stroke:#000000;stroke-width:47;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000060004548020511360810000016016281320388807819_);fill:none;stroke:#000000;stroke-width:47;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000004505276263751033410000008203891369087639194_);fill:none;stroke:#000000;stroke-width:47;stroke-linecap:round;stroke-miterlimit:10;}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000059276707895183830480000003300870360483448981_);fill:none;stroke:#000000;stroke-width:47;stroke-linecap:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000069392692880889155240000013351126780653018280_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 226.91,
    y: 226.04,
    width: 273.09,
    height: 633.38
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000048482344858059463080000011537324052851103880_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000048482344858059463080000011537324052851103880_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 47,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M559.35,835.93c0,0-197.04,0-222.66,0c-28.47,0-46.9-16.06-50.6-42.7l-34.16-543.68H500"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000129190923055560485420000001024619206328130471_"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000111180300022186348020000008209995840127517856_",
    x: 500,
    y: 226.04,
    width: 273.09,
    height: 633.38
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000116221025096215080910000018444882602983560860_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111180300022186348020000008209995840127517856_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000116221025096215080910000018444882602983560860_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 47,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M440.65,835.93c0,0,197.04,0,222.66,0c28.47,0,46.9-16.06,50.6-42.7l34.16-543.68H500"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000077300417125198488860000007983959102955073214_"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000133504021893060000670000007095392560355787663_",
    x: 343.97,
    y: 316.34,
    width: 182.14,
    height: 432.23
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011746127143712343650000006516324402844371858_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133504021893060000670000007095392560355787663_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000011746127143712343650000006516324402844371858_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 47,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 367.47,
    y1: 339.84,
    x2: 390.24,
    y2: 721.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000011746127143712343650000006516324402844371858_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 47,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 502.61,
    y1: 356.29,
    x2: 502.61,
    y2: 725.07
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000103251049716438819770000001119191803036391612_"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060012740665263644630000010564826005586506373_",
    x: 473.89,
    y: 316.34,
    width: 182.14,
    height: 432.23
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078042910766831173230000007880364227902323091_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060012740665263644630000010564826005586506373_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000078042910766831173230000007880364227902323091_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 47,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 632.53,
    y1: 339.84,
    x2: 609.76,
    y2: 721.75
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000078042910766831173230000007880364227902323091_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 47,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 497.39,
    y1: 356.29,
    x2: 497.39,
    y2: 725.07
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000146466836963282137160000002078618711100243897_"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000037663045844545724620000002792326741087202726_",
    x: 183.12,
    y: 140.4,
    width: 316.88,
    height: 131.45
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134215960409919629470000016067205998108926106_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037663045844545724620000002792326741087202726_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000134215960409919629470000016067205998108926106_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 47,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: " 206.62,248.36 389.27,248.36 507.33,248.36  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000134215960409919629470000016067205998108926106_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 47,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M521.87,163.9l-69.83,0c-23.4,0-44.91,14.23-44.91,45.54c0,38.27,0,38.27,0,38.27"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Mirror_Repeat_x3E__00000118364427050857252650000017410029215588949685_"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000023967014270823012470000001806668247834333841_",
    x: 500,
    y: 140.4,
    width: 316.88,
    height: 131.45
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121242404588616543530000013080116767638449591_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023967014270823012470000001806668247834333841_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      clipPath: "url(#SVGID_00000121242404588616543530000013080116767638449591_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 47,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: " 793.38,248.36 610.73,248.36 492.67,248.36  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000121242404588616543530000013080116767638449591_)",
      fill: "none",
      stroke: "#000000",
      strokeWidth: 47,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: " M478.13,163.9l69.83,0c23.4,0,44.91,14.23,44.91,45.54c0,38.27,0,38.27,0,38.27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashClosed);
export default __webpack_public_path__ + "static/media/trash_closed.eea30dba4f9697a9880a33cf9cdd825a.svg";
export { ForwardRef as ReactComponent };